<template>
  <div class="detail_content">
    <div class="detail_label_flex">
      {{ titleLabel }}
      <input type='checkbox' :class='nameValue' class='tenant_checkbox' :name='nameValue' checked>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titleLabel: String,
    notRequiredFlag: Boolean,
    nameValue: String
  },
  data() {
    return {
    }
  },
  computed: {
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    }
  },
  methods: {
    inputUpdate(e) {
      this.$emit('inputUpdate', e)
    }
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/checkBoxSection.vue